import { StatusBadge } from "../components/StatusBadge";
import { formatDateTime } from "../lib/format";
import type { StatusHistoryEntry, WorkItem } from "../types/domain";

export function TimelineView({
  history,
  items,
}: {
  history: StatusHistoryEntry[];
  items: WorkItem[];
}) {
  const itemById = new Map(items.map((item) => [item.id, item]));
  return (
    <div className="view-stack">
      <section className="section-toolbar">
        <div>
          <span className="eyebrow">Registro append-only</span>
          <h2>Timeline</h2>
          <p>Cada transición conserva estado anterior, estado nuevo, actor, motivo e instante.</p>
        </div>
      </section>
      <section className="panel timeline-panel">
        {history.length === 0 ? (
          <p className="muted">Todavía no existen transiciones.</p>
        ) : (
          <ol className="timeline-list">
            {history.map((entry) => {
              const item = itemById.get(entry.workItemId);
              return (
                <li key={entry.id}>
                  <span className="timeline-list__marker" />
                  <div className="timeline-list__content">
                    <div className="timeline-list__header">
                      <div>
                        <span className="eyebrow">{formatDateTime(entry.changedAt)}</span>
                        <h3>{item?.title ?? "Elemento eliminado"}</h3>
                      </div>
                      <StatusBadge status={entry.toStatus} />
                    </div>
                    <p>{entry.reason ?? "Transición sin motivo adicional."}</p>
                    {entry.fromStatus && <small>Desde: {entry.fromStatus}</small>}
                  </div>
                </li>
              );
            })}
          </ol>
        )}
      </section>
    </div>
  );
}
